/**
 * PATH: packages/email-hub/src/feature/components/email-reader/ReaderOverlays.tsx
 * FILE_ID: EMAILHUB-EMAILREADER-OVERLAYS-001
 * PURPOSE: Render link, job-peek, and board-peek overlays.
 */
import { BoardPeekPanel } from '../BoardPeekPanel';
import { JobPeekPanel } from '../JobPeekPanel';
import LinkToJobModal from '../LinkToJobModal';
import { RequestRuleDialog } from '../RequestRuleDialog';
import type { EmailReaderController } from './useEmailReaderController';

export function ReaderOverlays({ controller }: { controller: EmailReaderController }) {
  const {
    email,
    emailId,
    showLinkModal,
    setShowLinkModal,
    refetch,
    peekJob,
    setPeekJob,
    peekBoardOpen,
    setPeekBoardOpen,
    kanbanApi,
    kanbanOrgId,
    canRequestRule,
    ruleDialogOpen,
    setRuleDialogOpen,
    openPeekedJob,
    openPeekedBoard,
  } = controller;
  if (!email || !emailId) return null;

  return (
    <>
      {showLinkModal && (
        <LinkToJobModal
          emailId={emailId}
          emailSubject={email.subject || '(no subject)'}
          emailBody={email.body_text || email.body_preview || ''}
          emailFrom={email.from_address || ''}
          isOpen
          onClose={() => setShowLinkModal(false)}
          onLinked={refetch}
        />
      )}
      {peekJob != null && (
        <JobPeekPanel jobId={peekJob} onClose={() => setPeekJob(null)} onOpen={openPeekedJob} />
      )}
      {peekBoardOpen && email.allocation_summary && (
        <BoardPeekPanel
          summary={email.allocation_summary}
          api={kanbanApi}
          onClose={() => setPeekBoardOpen(false)}
          onOpen={openPeekedBoard}
        />
      )}
      {ruleDialogOpen && canRequestRule && kanbanOrgId != null && (
        <RequestRuleDialog
          api={kanbanApi}
          orgId={kanbanOrgId}
          emailId={email.id}
          senderAddress={email.from_address}
          category={email.category}
          onClose={() => setRuleDialogOpen(false)}
          onApplied={refetch}
        />
      )}
    </>
  );
}
